// extracted by mini-css-extract-plugin
export default {"DateTimePickerInput":"StyledPicker_DateTimePickerInput__3O8bT","DatepickerCalendar":"StyledPicker_DatepickerCalendar__cDcDY","ClearIcon":"StyledPicker_ClearIcon__AKIv4"};